module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShowSearch && _vm.options.length) ? _c('div', {
    staticClass: "m-2",
    class: {
      'd-flex flex-wrap mb-2': _vm.short
    }
  }, _vm._l((_vm.options), function(option, key) {
    return _c("tag", {
      key: typeof option === 'object' ? option[_vm.keyName] : key,
      tag: "component",
      attrs: {
        "title-name": _vm.titleName,
        "image-name": _vm.imageName,
        "key-name": _vm.keyName,
        "option": option,
        "short": _vm.short,
        "on-drop": _vm.handleDrop,
        "options-count": _vm.options.length
      }
    })
  })) : (!_vm.isShowSearch && _vm.options.length) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "m-0 d-inline-flex w-100"
  }, [(_vm.options.length) ? _c('div', {
    staticClass: "m-2",
    class: {
      'w-100': !_vm.short
    }
  }, _vm._l((_vm.options), function(option, key) {
    return _c("tag", {
      key: typeof option === 'object' ? option[_vm.keyName] : key,
      tag: "component",
      attrs: {
        "title-name": _vm.titleName,
        "image-name": _vm.imageName,
        "key-name": _vm.keyName,
        "option": option,
        "short": _vm.short,
        "on-drop": _vm.handleDrop,
        "options-count": _vm.options.length
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c("caret", {
    tag: "component",
    attrs: {
      "options-count": _vm.options.length,
      "dropdown-list-count": _vm.dropdownListCount,
      "is-show-dropdown-list": _vm.isShowDropdownList,
      "on-show-dropdown-list": _vm.onShowDropdownList,
      "on-hide-dropdown-list": _vm.onHideDropdownList
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38f517a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tags.vue
// module id = 101
// module chunks = 0